import * as base from 'store/bolt/pixels.js';
import Store from 'store/store';

function fireSonyConversion (data) {
	window.dataLayer = window.dataLayer || [];
	let retailer = data.provider;
	if (retailer === 'direct') {
		retailer = data.theater.chain?.slug || retailer;
	}
	pushToAllDataLayers({
		event: 'ticket_click',
		event_label: retailer,
		event_label_2: data.time,
		event_label_3: data.theater.name
	});
}

function pushToAllDataLayers(data) {
	let dataLayers = [
		Array.isArray(window.dataLayer) && window.dataLayer
	];

	try {
		dataLayers.push(window.top.dataLayerGTM);
	} catch (e) { /* ignore (window.top not available) */ }

	dataLayers.filter(e => e).forEach(dataLayer => dataLayer.push(data));
}

Store.on('SELECT_TIME', ({ theater, screening }) => {
	pushToAllDataLayers({ event: 'time_click', event_label: screening.time, event_label_2: theater.name });
});

Store.on('TICKET_CONVERSION', (data, page) => {
	const sonyDataLayer = Store.get()?.appData?.options?.sonyFeatures?.sonyDataLayer;
	if (sonyDataLayer) {
		fireSonyConversion(data);
	}
});

Store.on('FILTER_SET', (filter, value) => {
	if (filter === 'date') {
		pushToAllDataLayers({ event: 'filter_date', event_label: value });
	}
});

Store.on('LANDING', () => {
	const appData = Store.get().appData;
	const legalUpdatePopUp = appData.options.sonyFeatures?.legalUpdatePopUp;
	
	if (legalUpdatePopUp) {
		const copy = appData.copy.baseCopy;

		const title = copy.$LEGAL_UPDATE_TITLE || '';

		let content = copy.$LEGAL_UPDATE_TEXT || 'Our <a href="" target="_blank">Privacy and Cookies Policy</a> and <a href="" target="_blank">Terms of Use</a> have been updated effective June 26, 2022. If you have any questions regardng these policies, please email us at <a href="mailto:SPE_Privacy@spe.sony.com">SPE_Privacy@spe.sony.com</a>.';
		const timeoutDuration = 30000; // Default 30000ms which is 30sec.

		const pWrapper = document.createElement("div");
		const pStyle = document.createElement('style');
		const pHeader = document.createElement("strong");
		const pContent = document.createElement("div");
		const pBtnClose = document.createElement('i');

		// Set styles.
		const styles = '.legal-notice { font-family:"Helvetica", Arial; background: #fff; opacity: 0.9; color: #000; position: fixed; width: 90vw; max-width: 380px; height: "auto"; bottom: 20px; left: 20px; padding: 24px 16px; border-radius: 10px; z-index: 999999; box-shadow: 1px 1px 10px 0px rgba(0,0,0, .4%);} .legal-notice-content { color: black;} .legal-notice a { color: #007bff; text-decoration: none; background-color: transparent;} .btn-legal-notice-close { font-weight: bold; font-style: normal; position: absolute; right: 10px; top: 5px; cursor: pointer; text-align: center; width: 20px; height: 20px;}';
		pStyle.innerHTML = styles;

		// Set Header.
		pHeader.innerHTML = title;

		// Set Content.
		pContent.classList.add('legal-notice-content');
		pContent.innerHTML = content;

		// Set close button.
		pBtnClose.classList.add('btn-legal-notice-close');
		pBtnClose.innerText = 'X';

		// Set Poppup.
		pWrapper.classList.add('legal-notice');
		pWrapper.id = 'legal-notice';

		// Add Header and content to popup legal notice.
		pWrapper.appendChild(pStyle);
		pWrapper.appendChild(pHeader);
		pWrapper.appendChild(pBtnClose);
		pWrapper.appendChild(pContent);

		// Add legal notice to the site body.
		document.body.appendChild(pWrapper);

		pBtnClose.addEventListener("click", function() {
			document.body.removeChild(pWrapper);
		});

		// Remove the notice after 30 seconds of displaying it.
		window.setTimeout(function() {
			document.body.removeChild(pWrapper);
		}, timeoutDuration);
	}
});
